import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myCurrencyPipe',
})
export class MyCurrencyPipe implements PipeTransform {
    transform(numberToFormat: any, currencySymbol: string): string {
        return numberToFormat + ' ' + currencySymbol;
    }
}
